import React, { useMemo, useState } from 'react';
import T from 'prop-types';

import IndexedChart from './IndexedChart';
import GrowthChart from './GrowthChart';
import { ActivityMetricDropdown, activityMetrics } from '../../MetricLists';

const MetricOverview = ({ data, isPending, isPress }) => {
  const [selectedMetric, setSelectedMetric] = useState(Object.keys(activityMetrics)[0]);

  const metricOption = useMemo(
    () => ({
      value: selectedMetric,
      label: activityMetrics[selectedMetric],
    }),
    [selectedMetric]
  );

  return (
    <div className="metric-overview">
      <header className="metric-overview__header">
        <ActivityMetricDropdown selected={selectedMetric} onChange={setSelectedMetric} />
      </header>
      <div className="metric-overview__content">
        <IndexedChart
          series={data.time_series?.indexed}
          metricOption={metricOption}
          isPending={isPending}
          isPress={isPress}
        />
        <div className="section-separator--v" />
        <GrowthChart
          series={data.time_series?.growth}
          metricOption={metricOption}
          isPending={isPending}
          isPress={isPress}
        />
      </div>
    </div>
  );
};

MetricOverview.propTypes = {
  data: T.shape({
    time_series: T.shape({
      indexed: T.object,
      growth: T.object,
    }),
  }).isRequired,
  isPending: T.bool.isRequired,
  isPress: T.bool,
};

export default MetricOverview;
